(function(w,d){
  'use strict';
  if (w.__ES_PDP_PRIORITY_BOOT__) return;
  w.__ES_PDP_PRIORITY_BOOT__ = true;

  var assets = w.__ES_PDP_LAZY_ASSETS || {};
  var ES = w.ES || null;
  var loaded = Object.create(null);
  var promises = Object.create(null);

  function report(scope, error){
    try {
      if (typeof w.ESDebug === 'function') w.ESDebug(scope, error);
      else if (w.Shopify && w.Shopify.designMode && w.console && console.warn) console.warn('[EYESHELLS][' + scope + ']', error);
    } catch(_debugError) {}
  }

  function scheduleIdle(callback, timeout){
    if (ES && ES.scheduler && typeof ES.scheduler.idle === 'function') {
      return ES.scheduler.idle(callback, timeout);
    }
    var active = true;
    var id;
    var run = function(){ if (!active) return; active = false; callback(); };
    if (w.requestIdleCallback) id = w.requestIdleCallback(run, { timeout: timeout || 700 });
    else id = w.setTimeout(run, Math.min(timeout || 700, 120));
    return function(){
      if (!active) return;
      active = false;
      try {
        if (w.cancelIdleCallback && w.requestIdleCallback) w.cancelIdleCallback(id);
        else w.clearTimeout(id);
      } catch(e) {}
    };
  }

  function observeNear(element, callback, options){
    if (ES && ES.observe && typeof ES.observe.intersection === 'function') {
      return ES.observe.intersection(element, function(entry){
        if (entry && entry.isIntersecting) callback();
      }, options || {});
    }
    if (!('IntersectionObserver' in w)) return null;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (!entry.isIntersecting) return;
        try { io.disconnect(); } catch(e) {}
        callback();
      });
    }, options || {});
    io.observe(element);
    return function(){ try { io.disconnect(); } catch(e) {} };
  }

  function once(key, factory){
    if (loaded[key]) return Promise.resolve();
    if (promises[key]) return promises[key];

    try {
      promises[key] = Promise.resolve(factory()).then(function(){
        loaded[key] = true;
        delete promises[key];
      }).catch(function(error){
        delete promises[key];
        throw error;
      });
    } catch (error) {
      return Promise.reject(error);
    }
    return promises[key];
  }

  function absoluteUrl(url){
    try { return new URL(url, d.baseURI).href; } catch(e) { return String(url || ''); }
  }

  function findAssetNode(selector, attribute, url){
    var wanted = absoluteUrl(url);
    var nodes = d.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      try {
        if (absoluteUrl(node.getAttribute(attribute) || node[attribute]) === wanted) return node;
      } catch(e) {}
    }
    return null;
  }

  function loadScript(url){
    if (!url) return Promise.resolve();
    return new Promise(function(resolve, reject){
      var found = findAssetNode('script[src]', 'src', url);
      if (found && found.dataset.esLoadFailed === '1') {
        try { found.remove(); } catch(e) {}
        found = null;
      }
      if (found) {
        if (found.dataset.esLoaded === '1' || found.readyState === 'complete') return resolve();
        found.addEventListener('load', function(){ found.dataset.esLoaded = '1'; resolve(); }, { once:true });
        found.addEventListener('error', function(){
          found.dataset.esLoadFailed = '1';
          try { found.remove(); } catch(e) {}
          reject(new Error('Failed to load script: ' + url));
        }, { once:true });
        return;
      }
      var script = d.createElement('script');
      script.src = url;
      script.async = false;
      script.dataset.esDynamic = '1';
      script.onload = function(){ script.dataset.esLoaded = '1'; resolve(); };
      script.onerror = function(){
        script.dataset.esLoadFailed = '1';
        try { script.remove(); } catch(e) {}
        reject(new Error('Failed to load script: ' + url));
      };
      (d.body || d.head || d.documentElement).appendChild(script);
    });
  }

  function ensureStyle(url){
    if (!url) return Promise.resolve();
    return new Promise(function(resolve, reject){
      var found = findAssetNode('link[href]', 'href', url);
      if (found && found.dataset.esLoadFailed === '1') {
        try { found.remove(); } catch(e) {}
        found = null;
      }

      function ready(node){
        if (!node) return false;
        try { return !!node.sheet || node.dataset.esLoaded === '1'; }
        catch(e) { return node.dataset.esLoaded === '1'; }
      }

      function bind(node){
        if (ready(node)) { resolve(); return; }
        var settled = false;
        var timer = w.setTimeout(function(){
          if (settled) return;
          if (ready(node)) { settled = true; resolve(); }
          else {
            settled = true;
            node.dataset.esLoadFailed = '1';
            reject(new Error('Stylesheet timed out: ' + url));
          }
        }, 8000);
        node.addEventListener('load', function(){
          if (settled) return;
          settled = true;
          w.clearTimeout(timer);
          node.dataset.esLoaded = '1';
          resolve();
        }, { once:true });
        node.addEventListener('error', function(){
          if (settled) return;
          settled = true;
          w.clearTimeout(timer);
          node.dataset.esLoadFailed = '1';
          try { node.remove(); } catch(e) {}
          reject(new Error('Failed to load stylesheet: ' + url));
        }, { once:true });
      }

      if (found) {
        var rel = String(found.getAttribute('rel') || '').toLowerCase();
        if (rel.indexOf('stylesheet') === -1) {
          try {
            found.onload = null;
            found.removeAttribute('onload');
            found.removeAttribute('as');
            found.setAttribute('rel', 'stylesheet');
            found.dataset.esStylePromoted = '1';
          } catch(e) {}
        }
        bind(found);
        return;
      }

      var link = d.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.dataset.esDynamic = '1';
      var contract = d.querySelector('link[data-es-pdp-contract]');
      if (contract && contract.parentNode) contract.parentNode.insertBefore(link, contract);
      else d.head.appendChild(link);
      bind(link);
    });
  }

  function whenReady(fn){
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn, { once:true });
    else fn();
  }

  function quickviewAllowed(){
    try {
      if (typeof w.ES_quickViewAllowed === 'function') return w.ES_quickViewAllowed();
      if (w.matchMedia) return w.matchMedia('(min-width: 992px) and (hover: hover) and (pointer: fine)').matches;
    } catch(e) {}
    return false;
  }

  function fallbackToHref(trigger){
    try {
      var href = trigger && trigger.getAttribute ? trigger.getAttribute('href') : '';
      if (href && href !== '#' && !/^javascript:/i.test(href)) w.location.href = href;
    } catch(e) {}
  }

  function ensureRelatedModule(){
    return once('relatedModule', function(){
      return ensureStyle(assets.relatedCss).then(function(){
        return loadScript(assets.relatedJs);
      }).then(function(){
        try {
          if (w.ES_jqReady && typeof w.ES_jqReady === 'function') {
            w.ES_jqReady(function($){
              try { $(d).trigger('shopify:section:load'); } catch(e) {}
            });
          }
        } catch(e) {}
      });
    });
  }

  function ensureQuickviewBundle(){
    if (!quickviewAllowed()) return Promise.resolve();
    return once('quickviewBundle', function(){
      return ensureRelatedModule()
        // Quick View owns only its own runtime. Lens Builder is loaded later,
        // on Select Lenses intent, by es-quickview-select-lenses.js.
        .then(function(){ return loadScript(assets.quickviewJs); })
        .then(function(){ return loadScript(assets.quickviewLensJs); })
        .then(function(){
          try {
            if (quickviewAllowed() && w.jQuery && typeof w.quickView === 'function') w.quickView();
            if (w.ES_jqReady && typeof w.ES_jqReady === 'function') {
              w.ES_jqReady(function($){
                try { if (quickviewAllowed() && w.quickView) w.quickView(); } catch(e) {}
                try { $(d).trigger('shopify:section:load'); } catch(e2) {}
              });
            }
          } catch(e) {}
        });
    });
  }

  function ensureLensbuilder(){
    if (!assets.hasLensbuilder || !assets.lensbuilderJs) return Promise.resolve();
    if (w.__esLensBuilderBooted) { loaded.lensbuilder = true; return Promise.resolve(); }
    return once('lensbuilder', function(){
      return ensureStyle(assets.lensbuilderCss)
        .then(function(){ return loadScript(assets.lensbuilderJs); });
    });
  }

  function ensureFancybox(){
    return once('fancybox', function(){
      return loadScript(assets.fancyboxUmd)
        .then(function(){ return loadScript(assets.fancyboxBinder); });
    });
  }

  function observeRelated(){
    // Keep PDP lighter by loading related-products runtime only when the section is near view
    // or when the customer shows intent; avoid idle-loading it for every PDP visitor.
    var root = d.querySelector('[data-es-related-root]');
    if (!root) return;
    var kicked = false;
    var kick = function(){
      if (kicked) return;
      kicked = true;
      ensureRelatedModule().catch(function(error){ kicked = false; report('pdp-related-load', error); });
    };

    var stopNear = observeNear(root, function(){
      if (stopNear) { try { stopNear(); } catch(e) {} stopNear = null; }
      kick();
    }, { rootMargin: '1400px 0px' });
    if (!stopNear) scheduleIdle(kick, 1400);

    d.addEventListener('pointerenter', function(ev){
      if (ev.target && ev.target.closest && ev.target.closest('[data-es-related-root] .engoj_btn_quickview')) kick();
    }, true);

    d.addEventListener('focusin', function(ev){
      if (ev.target && ev.target.closest && ev.target.closest('[data-es-related-root] .engoj_btn_quickview')) kick();
    });

    var pendingButton = null;
    var replayPending = false;
    d.addEventListener('click', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-related-root] .engoj_btn_quickview') : null;
      if (!btn || !quickviewAllowed() || loaded.quickviewBundle) return;
      ev.preventDefault();
      ev.stopPropagation();
      if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
      pendingButton = btn;
      if (replayPending) return;
      replayPending = true;
      ensureQuickviewBundle().then(function(){
        var replay = pendingButton;
        pendingButton = null;
        replayPending = false;
        w.setTimeout(function(){
          if (replay && d.documentElement.contains(replay)) {
            try { replay.click(); } catch(e) {}
          }
        }, 30);
      }).catch(function(error){
        var fallback = pendingButton;
        pendingButton = null;
        replayPending = false;
        report('pdp-related-quickview', error);
        fallbackToHref(fallback);
      });
    }, true);
  }

  function prepareLensbuilderLaunch(){
    if (!assets.hasLensbuilder) return;
    function warm(){ ensureLensbuilder().catch(function(error){ report('pdp-lensbuilder-warm', error); }); }

    d.addEventListener('pointerenter', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-lensbuilder-launch]') : null;
      if (btn) warm();
    }, true);

    d.addEventListener('focusin', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-lensbuilder-launch]') : null;
      if (btn) warm();
    });

    d.addEventListener('touchstart', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-lensbuilder-launch]') : null;
      if (btn) warm();
    }, { passive:true, capture:true });

    var pendingButton = null;
    var replayPending = false;
    d.addEventListener('click', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-lensbuilder-launch]') : null;
      if (!btn || loaded.lensbuilder || w.__esLensBuilderBooted) return;
      ev.preventDefault();
      ev.stopPropagation();
      if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();

      if (pendingButton && pendingButton !== btn) pendingButton.removeAttribute('aria-busy');
      pendingButton = btn;
      btn.setAttribute('aria-busy', 'true');
      if (replayPending) return;
      replayPending = true;

      ensureLensbuilder().then(function(){
        var replay = pendingButton;
        pendingButton = null;
        replayPending = false;
        if (replay) replay.removeAttribute('aria-busy');
        w.setTimeout(function(){
          if (replay && d.documentElement.contains(replay)) {
            try { replay.click(); } catch(e) {}
          }
        }, 30);
      }).catch(function(error){
        var failed = pendingButton;
        pendingButton = null;
        replayPending = false;
        if (failed) failed.removeAttribute('aria-busy');
        report('pdp-lensbuilder-open', error);
      });
    }, true);

    scheduleIdle(warm, 3200);
  }

  function prepareFancybox(){
    function warm(){ ensureFancybox().catch(function(){}); }

    d.addEventListener('pointerenter', function(ev){
      var trigger = ev.target && ev.target.closest ? ev.target.closest('[data-fancybox]') : null;
      if (trigger) warm();
    }, true);

    d.addEventListener('focusin', function(ev){
      var trigger = ev.target && ev.target.closest ? ev.target.closest('[data-fancybox]') : null;
      if (trigger) warm();
    });

    // Mobile: preload the Fancybox runtime on touchstart, before the click event.
    d.addEventListener('touchstart', function(ev){
      var trigger = ev.target && ev.target.closest ? ev.target.closest('[data-fancybox]') : null;
      if (trigger) warm();
    }, { passive:true, capture:true });

    var pendingTrigger = null;
    var replayPending = false;
    d.addEventListener('click', function(ev){
      var trigger = ev.target && ev.target.closest ? ev.target.closest('[data-fancybox]') : null;
      if (!trigger || loaded.fancybox) return;
      ev.preventDefault();
      ev.stopPropagation();
      if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
      pendingTrigger = trigger;
      if (replayPending) return;
      replayPending = true;
      ensureFancybox().then(function(){
        var replay = pendingTrigger;
        pendingTrigger = null;
        replayPending = false;
        w.setTimeout(function(){
          if (replay && d.documentElement.contains(replay)) {
            try { replay.click(); } catch(e) {}
          }
        }, 30);
      }).catch(function(){
        var fallback = pendingTrigger;
        pendingTrigger = null;
        replayPending = false;
        fallbackToHref(fallback);
      });
    }, true);

    scheduleIdle(warm, 2600);
  }

  whenReady(function(){
    observeRelated();
    prepareLensbuilderLaunch();
    prepareFancybox();
  });
})(window, document);
